import {FC} from 'react';
import {styled} from 'styled-components';

import {Flex} from '@shared_web/components/core2/flex';

import {HEADER_HEIGHT} from '@mavismart_frontend/lib/constants';

interface DesktopTemplateProps {
  columns: JSX.Element[];
  columnsWidth?: (string | undefined)[];
  content: JSX.Element;
}

export const DesktopTemplate: FC<DesktopTemplateProps> = props => {
  const {columns, columnsWidth, content} = props;
  return (
    <Wrapper $height="100%">
      {columns.map((column, index) => (
        <Column
          key={column.key}
          $column
          $noShrink
          $height="100%"
          $width={columnsWidth?.[index] ?? '300px'}
        >
          {column}
        </Column>
      ))}
      <Content $column>{content}</Content>
    </Wrapper>
  );
};

DesktopTemplate.displayName = 'DesktopTemplate';

const Wrapper = styled(Flex)`
  margin-top: calc(${HEADER_HEIGHT}px + env(safe-area-inset-top));
  height: calc(100% - ${HEADER_HEIGHT}px - env(safe-area-inset-top));
`;

const Column = styled(Flex)`
  border-right: 1px solid #e0e0e0;
  overflow-y: auto;
`;

const Content = styled(Flex)`
  width: 0;
  flex-grow: 1;
`;
